import AbstractEntity from "../AbstractEntity";

export default class EmergencyInterventionDocument extends AbstractEntity {
    _id;
    _externalId;
    _pictureBeforeIds;
    _pictureAfterIds;
    _orderId;


    getId() {
        return this._id;
    }

    getExternalId() {
        return this._externalId;
    }

    getPictureBeforeIds() {
        return this._pictureBeforeIds;
    }

    getPictureAfterIds() {
        return this._pictureAfterIds;
    }

    getOrderId() {
        return this._orderId;
    }

    getClassName() {
        return "emergency_intervention_document";
    }
}